import { useState } from 'react';
import { useRouter } from '../../hooks/router';
import img_fav from '../Channels/images/favourite.png'
import img_fav_outline from '../Channels/images/outline_favourite.png'

export default ({
    channel,
    activeChannelId,
    btn_favourites
}) => {
    const router = useRouter()

    const [favourite, setFavourite] = useState(false);

    return (
        <div className={" card_channel_live " + (activeChannelId == channel.id ? 'selected' : '')} onClick={() => router.push(`?id=${channel.id}`)}>
            <img src={channel.image} className='img_card_channel_live' alt="" />
            <div className="info_channel_card">
                <h4 className="title_channel_live">{channel.name}</h4>
                <div className="icons_group_channel_card">
                    {!channel.canWatch ? <div className="icon_prem_channel icon_channel_card"></div> : null}
                    {channel.is_protected ? <div className="icon_lock_channel icon_channel_card"></div> : null}
                    {channel.archived_channel ? <div className="icon_rec_channel icon_channel_card"></div> : null}
                </div>
            </div>
            <div
                className="favourite_icon_card_live"
                onClick={(e) => {
                    e.stopPropagation()
                    btn_favourites(channel)
                }}
                style={{ backgroundImage: `url(${channel.is_favourite ? img_fav : img_fav_outline})` }}
            ></div>
        </div >
    )
}